export default {
  '&NameSplitter.No': 'No',
  '&NameSplitter.QuestionStart': 'Is',
  '&NameSplitter.QuestionEnd': 'your %name?',
  '&NameSplitter.Yes': 'Yes',
} as TextDictionary;
